module.exports = __webpack_public_path__ + "static/media/M_Block.0af09fd5.jpg";